// Hidden while ad integration is paused. Remove the `return null` and
// uncomment the block below to restore.
const AdSlot = (props) => {
    return null;
    /*
    return (
      <div className="py-3 text-center px-3" style={{ backgroundColor: '#f8f8f8', borderTop: '1px solid #eee', borderBottom: '1px solid #eee' }}>
        <div
          className="mx-auto d-flex align-items-center justify-content-center rounded w-100"
          style={{ maxWidth: 728, height: 90, backgroundColor: '#e9e9e9', border: '1px dashed #ccc' }}
          data-ad-slot={props.id}
        >
          <small className="text-muted">Ad &middot; {props.id} &middot; <em>Pro users: ad-free</em></small>
        </div>
      </div>
    )
    */
};
export default AdSlot;
